import { hasMinimumMobileSdkVersion } from 'visitor-ui-component-library/utils/isInSDK';
import { connect } from 'react-redux';
import { getEnableSdkCloseButton } from '../widget-data/selectors/getEnableSdkCloseButton';
import { getIsUngatedForCustomerAgentPrompts } from '../widget-data/selectors/widgetDataSelectors';
// @ts-expect-error untyped file
import CurrentView from './CurrentView';
import { getCurrentView } from './selectors/getCurrentView';
const mapStateToProps = state => {
  return {
    currentView: getCurrentView(state),
    enableSdkCloseButton: getEnableSdkCloseButton(state) && hasMinimumMobileSdkVersion({
      minMajor: 1,
      minMinor: 0,
      minPatch: 6
    }),
    isUngatedForCustomerAgentPrompts: getIsUngatedForCustomerAgentPrompts(state)
  };
};
export default connect(mapStateToProps)(CurrentView);